import { render, staticRenderFns } from "./firstDepositGift.vue?vue&type=template&id=3c501a90&scoped=true"
import script from "./firstDepositGift.vue?vue&type=script&lang=js"
export * from "./firstDepositGift.vue?vue&type=script&lang=js"
import style0 from "./firstDepositGift.vue?vue&type=style&index=0&id=3c501a90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c501a90",
  null
  
)

export default component.exports